/* eslint-disable max-len */
import React from 'react'
export default function EmptyScreenOtp({FirstPTag,SecondePTag}) {
    return (
        <>
            <div className='bg-white rounded-lg py-3 px-6 h-[calc(100vh-430px)] flex flex-col justify-center items-center'>
                <img src="/images/emptyscreen_img.png" alt="emptyscreen" className={`mx-auto`}/>
                <p id= "empty_screen" className="text-center text-xl font-normsl text-[#000]">{FirstPTag} <br />{SecondePTag}</p>
            </div>
           
        </>

       
    )
}
